module.exports = __webpack_public_path__ + "static/img/578fcfbb.c10.3a4a2c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/578fcfbb.c10.jpg
// module id = fp+Q
// module chunks = 2